import React, { Component } from 'react';
import '../App.css';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {isLoggedIn, ifMagazyn } from '../utils/AuthService';

var Utarg = React.createClass({

getInitialState: function() {

  return {
    addObject: {
      id: '',
      idZlecenie: '',
      kwotaWplaty: '',
      typPlatnosci: '',
      data: ''
    },
    dataFiltr: '',
    suma: 0.00,
    data: null,
    selectedUtargId: null
  }
  },

  onRowSelect: function(row, isSelected) {

		if(isSelected) {
			this.setState({ selectedUtargId: row.id });
		}else {
			this.setState({ selectedUtargId: null });
		}
	},

  onDeleteBtnClicked: function() {

    axios.delete('http://217.182.200.222:8080/utarg/' + this.state.selectedUtargId)
      .then(function (response) {
        this.refreshTable();
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },
  refreshTable: function() {

    axios.get('http://217.182.200.222:8080/utarg')
    .then(function (utarg) {
      this.setState({data: utarg.data});
    }.bind(this));
  },
  getUtargById: function(id) {

    for(var i in this.state.data) {
      if(this.state.data[i].id === id) {
        return this.state.data[i];
      }
    }
    return '';
  },

  wyliczSumeZaDzien: function(dataFiltr) {
    this.state.suma = 0.00
    var suma = parseFloat(0.00);
    var aa = parseFloat(0.00);
    for(var i in this.state.data) {
      if(this.state.data[i].data == dataFiltr) {
        aa= parseFloat(this.state.data[i].kwotaWplaty)
        suma = parseFloat(aa * 1)

        parseFloat(this.state.suma += parseFloat(suma + 0.00))
      }
    }
  },


  render: function() {

    var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};


  return (


    <div>

	<div className="form-group">

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="numerZlecenia">Numer zlecenia: </label>
					</div>
					<div className="col-sm-8">
            <FormControl
              type="text"
              placeholder="Numer zlecenia"
              value={this.state.addObject.idZlecenie}
              onChange={this.onAddUtargZlecenieChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8">


      <div className="row">
      <div className="col-sm-6">
      </div>
        <div className="col-sm-2">
          <Button bsStyle="primary" onClick={this.onWyliczSumeClicked}>wylicz sume</Button>
        </div>
        <div className="col-sm-4">
        <FormControl
          type="date"
          value={this.state.dataFiltr}
          onChange={this.onDataFiltrChange} />
        </div>
      </div>
      </div>
		</div>

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="cenaZaMb">Typ płatności: </label>
					</div>
					<div className="col-sm-8">
            <select className="form-control" id="punktSprzedazy"
                  value={this.state.addObject.typPlatnosci}
                  onChange={this.onAddUtargTypPlatnosciChange} >
              <option>Wybierz typ płatności</option>
              <option>Karta</option>
              <option>Gotówka</option>
            </select>
					</div>
				</div>
			</div>
			<div className="col-sm-8">


      <div className="row">
      <div className="col-sm-6">
      </div>
        <div className="col-sm-2">
          <label htmlFor="cenaZaMb">Suma utargu: </label>
        </div>
        <div className="col-sm-4">
          <label htmlFor="cenaZaMb">{this.state.suma.toFixed(2)} zł</label>
        </div>
      </div>
      </div>

      <div/>
		</div>

    <div className="row">
      <div className="col-sm-4">
        <div className="row">
          <div className="col-sm-4">
            <label htmlFor="cenaZaMb">Kwota wpłaty: </label>
          </div>
          <div className="col-sm-8">
          <FormControl
            type="text"
            placeholder="Kwota wpłaty"
            value={this.state.addObject.kwotaWplaty}
            onChange={this.onAddUtargKwotaChange} />
          </div>
        </div>
      </div>
      <div className="col-sm-8"/>
    </div>

	</div>

  <div>
  <Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj rekord do utargu</Button>
  </div>
    <br/>
  <BootstrapTable data={this.state.data}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          selectRow={selectRowProp}>
    <TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="idZlecenie" dataSort={true}>Numer zlecenia</TableHeaderColumn>
    <TableHeaderColumn dataField="typPlatnosci">Typ płatności</TableHeaderColumn>
    <TableHeaderColumn dataField="kwotaWplaty">Kwota wpłaty</TableHeaderColumn>
    <TableHeaderColumn dataField="data">Data</TableHeaderColumn>
  </BootstrapTable>

<br/>
<div>
<Button bsStyle="danger" onClick={this.onDeleteBtnClicked}>Usuń rekord utargu</Button>
</div>

</div>
  );
},

componentDidMount: function() {
  this.refreshTable();
},


clearAddObject: function() {

  this.state.addObject.id = null;
  this.state.addObject.idZlecenie = '';
  this.state.addObject.typPlatnosci = '';
  this.state.addObject.kwotaWplaty = '';

},

onAddUtargZlecenieChange: function(event) {
  this.state.addObject.idZlecenie = event.target.value;
  this.forceUpdate();
},

onAddUtargTypPlatnosciChange: function(event) {
  this.state.addObject.typPlatnosci = event.target.value;
  this.forceUpdate();
},

onAddUtargKwotaChange: function(event) {
  this.state.addObject.kwotaWplaty = event.target.value.replace(/,/g, '.');
  this.forceUpdate();
},

onDataFiltrChange: function(event) {
  this.state.dataFiltr = event.target.value;
  this.forceUpdate();
},

onWyliczSumeClicked: function(){
this.forceUpdate();
  this.wyliczSumeZaDzien(this.state.dataFiltr);
},

onAddBtnClicked: function() {
  axios.post('http://217.182.200.222:8080/utarg/', this.state.addObject)
    .then(function (response) {
      this.refreshTable();
    }.bind(this))
    .catch(function (error) {
      alert("Błędnie wprowadzone dane");
      console.log(error);
    });

    this.setState({
      addObject: {
        id: '',
        idZlecenie: '',
        kwotaWplaty: '',
        typPlatnosci: ''
      }
    });
}
});

export default Utarg;



// WEBPACK FOOTER //
// ./src/components/Utarg.js